module.exports = __webpack_public_path__ + "img/ignacio-bordigoni-byn.1a08b60c.jpg";